module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_small_de-56472817c368cb12b074175d45bd678e.jpg";